import './index.css'
import {useFieldArray} from "react-hook-form";
import Button from "@/components/common/Button";
import Table from "@/components/common/Table";
import {useAppDispatch} from "@/store";
import {ReactComponent as RiAddLine} from "@/assets/icons/ri-add-line.svg";
import {ReactComponent as RiEditLine} from "@/assets/icons/ri-edit-line.svg";
import {venueDetailActions} from "@/store/venue-detail/slice";

const META: TableSummarizeMeta = {
  startItem: 1,
  endItem: 20,
  totalItem: 2290,
  pageNumber: 1,
  lastPage: 20
}
const HEADERS: TableHeader[] = [
  {
    label: 'Class',
    key: 'name'
  },
  {
    label: 'Action',
    key: 'generatedId',
    classNames: 'w-1/4'
  }
]
const SORT: TableSort = {
  type: 'SERVER',
  handler: () => {}
}

const renderAction = (openModal: Function, generatedId: string) => (
  <Button
    onClick={(e: Event) => {
      e.preventDefault()
      openModal(generatedId)
    }}
    type={null}
    variant="secondary"
    className="border-stroke-subtle border px-4"
  >
    <div className="flex gap-2 justify-center items-center">
      <RiEditLine />
      Edit
    </div>
  </Button>
)
const getTableBodyData = (prices: PriceVO[]) : TableBodyData[] => prices.map((p) => ({
  id: p.generatedId,
  value: p
}))
const getTableBody = (prices: PriceVO[], openModal: Function) : TableBody => ({
  data: getTableBodyData(prices),
  component: {
    price: (name) => (<span className="text-jsm font-bold">{name}</span>),
    generatedId: (generatedId) => renderAction(openModal, generatedId)
  }
})

const Pricing = () => {
  const dispatch = useAppDispatch()
  const pricesField = useFieldArray({
    name: 'prices',
    keyName: 'generatedId'
  })
  const mappedPrices = pricesField.fields as PriceVO[]

  const openModal = (generatedId?: string) => {
    const payload: ShowModalActionPayload = {
      show: true,
      currentPrice: mappedPrices.find(p => p.generatedId === generatedId),
      currentPriceIndex: mappedPrices.findIndex(p => p.generatedId === generatedId)
    }
    dispatch(venueDetailActions.showPriceModal(payload))
  }
  const handleClickAddPricing = (e: Event) => {
    e.preventDefault()
    openModal(null)
  }

  return (
    <div className="card-base w-full flex flex-col gap-7">
      <div className="text-jlg">Pricing Class</div>
      <div className="w-full">
        <Table
          renderMeta={false}
          headers={HEADERS}
          sort={SORT}
          meta={META}
          body={getTableBody(mappedPrices, openModal)} />
      </div>
      <div className="w-full flex justify-end">
        <Button
          onClick={handleClickAddPricing}
          type={null}
          variant="primary"
          className="whitespace-nowrap flex gap-2 pl-4 py-2 justify-center items-center">
          <div className="w-[18px]">
            <RiAddLine/>
          </div>
          <span className="text-jsm">Pricing Class</span>
        </Button>
      </div>
    </div>
  )
}

export default Pricing;
